import { render, staticRenderFns } from "./CopyElementWrapper.vue?vue&type=template&id=46cb8393&scoped=true"
import script from "./CopyElementWrapper.vue?vue&type=script&lang=ts"
export * from "./CopyElementWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CopyElementWrapper.vue?vue&type=style&index=0&id=46cb8393&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cb8393",
  null
  
)

export default component.exports